import { pathOr } from 'ramda';
import { takeEvery, takeLatest, call, put, select } from 'redux-saga/effects';

import contactService from 'services/contactService';
import searchService from 'services/searchService';

import {
  contactSearch,
  fetchContact,
  types,
  paginateContacts,
} from './actions';
import { getSearchTerm } from './reducer';

export default function* root() {
  yield takeLatest(types.CONTACT_SEARCH_REQUEST, watchContactSearch);
  yield takeEvery(types.FETCH_CONTACT_REQUEST, watchFetchContact);
  yield takeLatest(types.PAGINATE_CONTACT_REQUEST, watchPaginateContacts);
}

function* watchContactSearch(action) {
  const { search, searchFields, searchFilters, paginateFrom } = action.payload;
  try {
    const response = yield call(searchService.contacts, {
      query: search,
      fields: (searchFields || []).length ? searchFields : undefined,
      filters: searchFilters || undefined,
      paginate_from: paginateFrom,
    });
    yield put(
      contactSearch.success({
        searchResults: pathOr([], ['results'], response),
        count: pathOr([], ['count'], response),
      }),
    );
  } catch (error) {
    yield put(contactSearch.error(error));
  }
}

function* watchFetchContact(action) {
  try {
    const { contactId } = action.payload;
    const contact = yield call(contactService.contacts.get, contactId);
    yield put(fetchContact.success({ contact }));
  } catch (error) {
    console.error('Failed to fetch contact.', error);
  }
}

function* watchPaginateContacts(action) {
  const { searchFields, searchFilters, paginateFrom } = action.payload;
  try {
    const searchTerm = yield select(getSearchTerm);
    const response = yield call(searchService.contacts, {
      query: searchTerm,
      fields: (searchFields || []).length ? searchFields : undefined,
      filters: searchFilters || undefined,
      paginate_from: paginateFrom,
    });
    yield put(
      paginateContacts.success({
        searchResults: pathOr([], ['results'], response),
      }),
    );
  } catch (error) {
    yield put(paginateContacts.error(error));
  }
}
